<template>
  <div
    class="fixed inset-0 z-[100] flex items-center justify-center bg-ink/50 px-4"
  >
    <div ref="dialogPanel" role="dialog" aria-modal="true" :aria-labelledby="dialogTitleId" tabindex="-1" @keydown="onDialogKeydown" class="w-full max-w-sm paper-card rounded-md p-5">
      <div class="flex items-start justify-between gap-2 mb-2">
        <h2 :id="dialogTitleId" class="text-[16px] font-semibold">{{ title }}</h2>
        <button
          @click="$emit('close')"
          class="shrink-0 w-7 h-7 rounded-full flex items-center justify-center hover:bg-[hsl(var(--muted))] transition-colors"
          :aria-label="$t('gradeModal.close')"
        >
          <X class="w-4 h-4" />
        </button>
      </div>
      <p class="text-[13px] text-[hsl(var(--foreground)/0.8)] leading-relaxed">
        <slot />
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { useDialogA11y } from "../composables/useDialogA11y";
import { X } from "lucide-vue-next";

defineProps<{ title: string }>();
const emit = defineEmits<{ (e: "close"): void }>();

// Доступность окна: ловушка фокуса, Esc, возврат фокуса (useDialogA11y).
const dialogPanel = ref<HTMLElement | null>(null);
const { titleId: dialogTitleId, onKeydown: onDialogKeydown } = useDialogA11y(dialogPanel, { onClose: () => emit('close') });
</script>
